import { z } from 'zod'

/**
 * Body for `POST /auth/dev/impersonate` (non-prod only).
 *
 * Caller provides either a user email or a user id (UUID). When both are
 * provided, `userId` takes precedence. The endpoint is admin-gated and
 * stage-gated; see ADR-0009.
 */
export const impersonateRequestSchema = z
	.object({
		email: z.email().optional(),
		userId: z.uuid().optional(),
	})
	.refine((v) => Boolean(v.email || v.userId), {
		message: 'email or userId is required',
	})

export type ImpersonateRequestInput = z.infer<typeof impersonateRequestSchema>
